import { useCallback } from 'react';
import { toast } from 'sonner';
import { exportAssetsToCSV } from '@/utils/exportUtils';

export function useAssetsBulkExport(filteredAssets: any[] | null | undefined, selectedAssets: string[]) {
  return useCallback(() => {
    const selectedAssetData = (filteredAssets || []).filter((asset: any) => selectedAssets.includes(asset.id));
    if (!selectedAssetData.length) {
      toast.error('Select assets to export');
      return;
    }
    try {
      exportAssetsToCSV(selectedAssetData as any);
      toast.success(`Exported ${selectedAssetData.length} assets`);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Bulk export failed', err);
      toast.error('Failed to export assets');
    }
  }, [filteredAssets, selectedAssets]);
}
